import axios from 'axios'

const cmsApi = axios.create({
  baseURL: `//${import.meta.env.VITE_CDN_HOST}/cms/v1/mscw`,
})

const _convertObject = (data) => {
  if (typeof data !== 'object' || !data) return data
  Object.keys(data).forEach((key) => {
    const value = data[key]
    if (typeof value === 'object') {
      return _convertObject(value)
    }
    if (typeof value === 'string' && value.startsWith('/media')) {
      data[key] = `//${import.meta.env.VITE_CDN_HOST?.replace('pre.', '')}${value}`
    }
  })
}

const _convertMedia = (response) => {
  _convertObject(response.data)
  return response
}

cmsApi.interceptors.response.use(_convertMedia)

// The MapleStory CMS's MSCW content (e.g. classes-jobs), on the same CDN
const maplestoryCmsApi = axios.create({
  baseURL: `//${import.meta.env.VITE_CDN_HOST}/maplestory/cms/mscw`,
})

maplestoryCmsApi.interceptors.response.use(_convertMedia)

// The MSCW CMS's own content (e.g. the landing page's), on the same CDN
const mscwCmsApi = axios.create({
  baseURL: `//${import.meta.env.VITE_CDN_HOST}/mscw/cms`,
})

mscwCmsApi.interceptors.response.use(_convertMedia)

const mscwApi = axios.create({
  baseURL: '/api/maplestory/v1',
})

const mscwApiV2 = axios.create({
  baseURL: '/api/maplestory/v2',
})

export { cmsApi, maplestoryCmsApi, mscwCmsApi, mscwApi, mscwApiV2 }
